import RingbaTokensAPI from '@/api/ringba-tokens.api'

/**
 * Generates a token name with the current epoch timestamp
 * @param {string} baseName - The base name for the token (e.g., 'Default Token')
 * @returns {string} The token name with epoch timestamp appended (e.g., 'Default Token - 1706745600')
 */
export function generateTokenName(baseName = 'Default Token') {
  const epochTimestamp = Math.floor(Date.now() / 1000)
  
  return `${baseName} - ${epochTimestamp}`
}

const state = {
  tokens: []
}

/** 
 * @type {import('vuex').GetterTree<typeof state>} 
 */
const getters = {
  defaultToken(state) {
    const tokens = Array.isArray(state.tokens) ? state.tokens : []
    return tokens.find(token => token?.default === true)
  }
}

/** 
 * @type {import('vuex').ActionTree<typeof state>} 
 */
const actions = {
  async fetchTokens({ commit }, { accountId }) {
    const response = await RingbaTokensAPI.listTokens(accountId)
    commit('SET_TOKENS', response.data)
    return response
  },

  async createToken({ dispatch }, { accountId, tokenDetails }) {
    const response = await RingbaTokensAPI.createToken(accountId, tokenDetails)

    await dispatch('fetchTokens', { accountId })

    return response
  },

  async deleteToken({ commit }, { accountId, tokenId }) {
    const response = await RingbaTokensAPI.deleteToken(accountId, tokenId)
    commit('REMOVE_TOKEN', tokenId)
    return response
  },

  async setDefaultToken({ dispatch }, { accountId, tokenId }) {
    const response = await RingbaTokensAPI.setDefaultToken(accountId, tokenId)
    await dispatch('fetchTokens', { accountId })
    return response
  }
}

/** 
 * @type {import('vuex').MutationTree<typeof state>} 
 */
const mutations = {
  SET_TOKENS(state, tokens) {
    state.tokens = tokens
  },

  ADD_TOKEN(state, token) {
    state.tokens.push(token)
  },

  REMOVE_TOKEN(state, tokenId) {
    state.tokens = state.tokens.filter(token => token.id !== tokenId)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}